import { compose, withHandlers, mapProps } from 'recompose'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { withRouter } from 'react-router-dom'
import get from 'lodash/get'

import {
  deleteOrderParty,
  getOrderParty,
  joinOrderParty,
  leaveOrderParty,
  detachParty,
} from 'store/order-party/order-party.actions'

import OrderParty from './OrderParty'
import withAuthState from 'enhancers/withAuthState'
import withCustomer from 'enhancers/withCustomer'

import {
  selectIsLeader,
  selectIsLoaded,
  selectIsLoading,
  selectIsMember,
  selectOrderParty,
} from 'store/order-party/order-party.selectors'

import { selectVenueNameById } from 'pages/vendor/modules/info'

import withNotifications from 'enhancers/withNotifications'

import slugify from 'utils/slugify'

const withOrderPartyContainer = connect(
  createSelector(
    selectIsLeader,
    selectIsLoaded,
    selectIsLoading,
    selectIsMember,
    selectOrderParty,
    createSelector(
      (state, ownProps) => selectVenueNameById(state, ownProps.venueId),
      venueName => venueName,
    ),
    (isLeader, isLoaded, isLoading, isMember, party, venueName) => ({
      party,
      isMember,
      isLeader,
      isLoading,
      isLoaded,
      venueSlug: slugify(venueName),
    }),
  ),
  {
    getOrderParty,
    joinOrderParty,
    leaveOrderParty,
    deleteOrderParty,
    detachParty,
  },
)

export default compose(
  withAuthState,
  withCustomer,
  withRouter,
  mapProps(ownProps => ({
    venueId: get(
      ownProps,
      'match.params.venueId',
      get(ownProps, 'match.params.id'),
    ),
    ...ownProps,
  })),
  withOrderPartyContainer,
  withNotifications,
  withHandlers({
    onLeave: ({
      party,
      isLeader,
      venueId,
      deleteOrderParty,
      leaveOrderParty,
    }) => () => {
      if (isLeader) {
        return deleteOrderParty({
          orderPartyId: party.id,
          venueId,
        }).catch(err => {
          console.error(err)
        })
      } else {
        return leaveOrderParty({
          orderPartyId: party.id,
          venueId,
        }).catch(err => {
          console.error(err)
        })
      }
    },
  }),
)(OrderParty)
